import PropTypes from 'prop-types';
import { isSystemOrganisation } from '../../../../app/config/systemOrgs';

const ConditionalOrganisationMenu = ({ item: { id }, children }) => {
  if (isSystemOrganisation(id)) return null;

  return children;
};

ConditionalOrganisationMenu.propTypes = {
  children: PropTypes.node.isRequired,
  item: PropTypes.object.isRequired,
};

export default ConditionalOrganisationMenu;
